// Books data - Add your books here
export const books = [
  {
    id: 1,
    title: "Crafting The Future Mind",
    subtitle: "Essential Books for Anyone Who Wants to Understand the World",
    cover: null,
    description: "A carefully curated guide to the essential books that shape how you think, lead, build, and understand the world — handpicked by Tboye Creative Solutions for curious minds ready to level up.",
    genre: "Mind & Growth",
    publishedDate: "2026-06-02",
    pages: null,
    pdfUrl: "/books/Crafting The Future Mind.pdf",
    readUrl: "/books/Crafting The Future Mind.pdf",
    purchaseUrl: null,
    featured: true,
  },
  {
    id: 2,
    title: "Build From Here: A Developer's Playbook for Africa",
    subtitle: "From Side Projects to Global Clients — Written From Inside the Experience",
    cover: null,
    description: "A raw, practical guide for African developers on how to go from building side projects to landing clients, running a tech business, and shipping products that matter globally. Written from Ghana, not from a distance.",
    genre: "Tech & Entrepreneurship",
    publishedDate: null,
    pages: null,
    pdfUrl: null,
    purchaseUrl: null,
    featured: false,
    comingSoon: true,
  },
  {
    id: 3,
    title: "The African AI Advantage",
    subtitle: "Why African Builders Are Better Positioned Than They Think",
    cover: null,
    description: "Not about catching up. About why African builders are uniquely positioned to build AI-native products — fewer legacy systems, closer to real problems, nothing to unlearn. Written from inside the experience of building AI tools in Ghana and shipping them globally.",
    genre: "AI & Strategy",
    publishedDate: "2026-09-09",
    pages: null,
    pdfUrl: "/books/The African AI Advantage.pdf",
    readUrl: "/books/The African AI Advantage.pdf",
    purchaseUrl: null,
    featured: false,
    comingSoon: false,
  },
  {
    id: 4,
    title: "The African AI Disadvantages",
    subtitle: "The Real Barriers No One Talks About",
    cover: null,
    description: "The honest counterpart. The infrastructure gaps, the funding walls, the connectivity problems, the brain drain — an unflinching look at what actually holds African AI builders back and what it will take to change it.",
    genre: "AI & Strategy",
    publishedDate: "2026-09-09",
    pages: null,
    pdfUrl: "/books/The African AI Disadvantages.pdf",
    readUrl: "/books/The African AI Disadvantages.pdf",
    purchaseUrl: null,
    featured: false,
    comingSoon: false,
  },
];
